﻿import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basiscs/tk.manager';
import TKRequestManager from '@tk/basiscs/tk.request.manager';
import TKButtonDropdown from '@tk/controls/tk.button.dropdown';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKHeader from '@tk/components/tk.header';
import TKViewport from '@tk/basiscs/tk.viewport';
import TKBasketButton from '@tk/components/tk.basket.button';
import TKCarousel from '@tk/components/tk.carousel';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKMinibasket from '@tk/components/tk.minibasket';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKDialog from '@tk/components/tk.dialog';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKSelection from '@tk/controls/tk.selection';
import TKArtSpecTable from '@tk/components/tk.art.spec.table';
import TKCompareButton from '@tk/components/tk.compare.button';
import TKShowMore from '@tk/components/tk.show.more';
import TKSelectRedirect from '@tk/controls/tk.select.redirect';
import TKPopup from '@tk/components/tk.popup';
import TKArticleListSort from '@tk/components/tk.article.list.sort';
import TKArticleListLayoutSwitch from '@tk/components/tk.article.list.layout.switch';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKCompareListLink from '@tk/components/tk.compare.list.link';
import TKFormTimepicker from '@tk/controls/tk.form.timepicker';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import TKFormZipCity from '@tk/controls/tk.form.zipcity';
import TKTable from '@tk/components/tk.table';
import KWArticleList from '@/components/kw.article.list';
import KWTracker from '@/components/kw.tracker';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import KWBasketButton from '@/components/kw.basket.button';
import KWBasketReference from '@/components/kw.basket.reference';
import KWSearch from '@/controls/kw.search';
import KWToggleSubmitter from '@/components/kw.toggle.submitter';
import KWAssetGallery from '@/components/kw.asset.gallery';
import KWTable from '@/components/kw.table';
import KWProductVariants from '@/components/kw.product.variants';
import KWPrice from '@/components/kw.price';
import KWStock from '@/components/kw.stock';
import KWFileUploadArea from '@/components/kw.file.upload.area';
import KWSectionToggler from '@/components/kw.section.toggler';
import KWDialog from '@/components/kw.dialog';
import KWSelectRedirect from '@/controls/kw.select.redirect';
import KWFormElement from '@/components/kw.form.element';
import KWTourSchedule from '@/components/kw.tour.schedule';
import KWTracking from '@/components/kw.tracking';
import KWFavoriteButton from '@/components/kw.favorite.button';
import KWArtSpecTable from '@/components/kw.art.spec.table';
import KWAsync from '@/components/kw.async';
import KWFormTracker from '@/components/kw.form.tracker';
import KWScan from '@/components/kw.scan';
import KWTabsTab from '@/components/kw.tabs.tab';

import 'tippy.js/dist/tippy.css';
import 'flatpickr/dist/flatpickr.min.css';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@scss/modules/article.scss';

export default class Article extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'kw-tracker', constructor: KWTracker },
            { name: 'tk-request-manager', constructor: TKRequestManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'kw-form-tracker', constructor: KWFormTracker },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-search', constructor: KWSearch },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-minibasket', constructor: TKMinibasket },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-article-list', constructor: KWArticleList },
            { name: 'tk-price', constructor: KWPrice },
            { name: 'tk-stock', constructor: KWStock },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-favorite-button', constructor: KWFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-art-spec-table', constructor: TKArtSpecTable },
            { name: 'kw-art-spec-table', constructor: KWArtSpecTable },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-show-more', constructor: TKShowMore },
            { name: 'tk-select-redirect', constructor: TKSelectRedirect },
            { name: 'tk-popup', constructor: TKPopup },
            { name: 'tk-article-list-sort', constructor: TKArticleListSort },
            { name: 'tk-article-list-layout-switch', constructor: TKArticleListLayoutSwitch },
            { name: 'tk-compare-list-link', constructor: TKCompareListLink },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'kw-table', constructor: KWTable },
            { name: 'kw-basket-button', constructor: KWBasketButton },
            { name: 'kw-basket-reference', constructor: KWBasketReference },
            { name: 'kw-toggle-submitter', constructor: KWToggleSubmitter },
            { name: 'kw-asset-gallery', constructor: KWAssetGallery },
            { name: 'kw-product-variants', constructor: KWProductVariants },
            { name: 'tk-file-upload-area', constructor: KWFileUploadArea },
            { name: 'kw-section-toggler', constructor: KWSectionToggler },
            { name: 'tk-form-timepicker', constructor: TKFormTimepicker },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'kw-dialog', constructor: KWDialog },
            { name: 'kw-select-redirect', constructor: KWSelectRedirect },
            { name: 'tk-form-zip-city', constructor: TKFormZipCity },
            { name: 'kw-form-element', constructor: KWFormElement },
            { name: 'kw-tour-schedule', constructor: KWTourSchedule },
            { name: 'tk-table', constructor: TKTable },
            { name: 'kw-tracking', constructor: KWTracking },
            { name: 'kw-async', constructor: KWAsync },
            { name: 'kw-scan', constructor: KWScan },
            { name: 'tk-tabs-tab', constructor: KWTabsTab },
        ]);
    }
}

new Article();
